"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var firstToUpper = function firstToUpper(value) {
  return value.split("").map(function (letter, index) {
    return index === 0 ? letter.toUpperCase() : letter.toLowerCase();
  }).join("");
};

var swapLastToFirst = function swapLastToFirst(accumulator, currentValue, currentIndex, array) {
  if (currentIndex >= array.length - 1) {
    accumulator.splice(0, 0, currentValue);
  } else {
    accumulator.push(currentValue);
  }

  return accumulator;
};

var _default = function _default(value) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _opts$separator = opts.separator,
      separator = _opts$separator === void 0 ? "," : _opts$separator;
  return value.split(" ").map(firstToUpper).reduce(swapLastToFirst, []).map(function (name, index, arr) {
    return index === 0 && arr.length > 1 ? name + separator : name;
  }).join(" ");
};

exports["default"] = _default;